import { Logger } from '@frontend/logger';
import { useState } from 'react';

import { VERSION } from '../version';

export const DevIndicator = () => {
    const [show, setShow] = useState<boolean>(true);
    Logger.log('version', VERSION);
    if (!show) return null;
    if (!(process.env['NX_PUBLIC_BUILD_ENV'] === 'development' || process.env['NX_PUBLIC_BUILD_ENV'] === 'test')) return null;
    return (
        <span className='bg-always-black/20 absolute bottom-0 left-0 z-50 flex h-6 w-full flex-row items-center justify-between text-stone-950'>
            <span className='bg-status-success text-always-white px-4'>{process.env['NX_PUBLIC_BUILD_ENV']}</span>
            <span className='px-4'>
                <span className='mr-2 font-bold'>Version: </span>
                {VERSION}
            </span>
            <button
                onClick={() => setShow(false)}
                className='px-4'>
                X
            </button>
        </span>
    );
};
